import { useStaticData } from '@mc/static-data-react'
import { CourseMeta, Outcome, OutcomeContent } from 'types/data'
import { TrackVisible } from '../../tracking'
import { getFeaturedInstructors } from '../../utils'
import { HeroDesktop } from '../HeroDesktop'
import { HeroMobile } from '../HeroMobile'

export const Hero = () => {
  const { outcome, outcomeRankedContent, courseSlugToMeta } = useStaticData<{
    outcome: Outcome
    outcomeRankedContent: OutcomeContent[]
    courseSlugToMeta: Record<string, CourseMeta>
  }>()

  const [featuredInstructor1, featuredInstructor2] = getFeaturedInstructors(
    outcome,
    outcomeRankedContent,
    courseSlugToMeta,
  )

  const heroProps = {
    heading: outcome.name,
    subheading: outcome.oneLiner,
    img1Url: featuredInstructor1?.imageUrl,
    img1Alt: featuredInstructor1?.name,
    img2Url: featuredInstructor2?.imageUrl,
    img2Alt: featuredInstructor2?.name,
  }

  return (
    <TrackVisible event='outcomeRowViewed' row_name={`hero:${outcome.name}`}>
      <>
        <HeroMobile {...heroProps} />
        <HeroDesktop {...heroProps} />
      </>
    </TrackVisible>
  )
}
